import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubscriptionDatabaseInfo  {
    _originalTypeClassName = "zAppDevManager.BO.SubscriptionDatabaseInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubscriptionDatabaseInfo.translate = translateService;
}
this.Id = null;
this.Server = null;
this.User = null;
this.Password = null;
this.Dialect = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Server:any;
User:any;
Password:any;
Dialect:any;
Type:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}